import React, { useState } from "react";

const Faq = ({ faqs }) => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  return (
    <section className="py-[125px] px-[125px] frequently-Asked">
      <div className="text-center mb-8">
        <h2 className="mb-4">Frequently Asked Questions</h2>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-lg shadow-md overflow-hidden"
          >
            <button
              onClick={() => toggleQuestion(index)}
              className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-100 focus:outline-none"
            >
              <h3
                dangerouslySetInnerHTML={{
                  __html: faq.question,
                }}
              ></h3>
              <span className="ml-4 text-2xl">
                {openQuestion === index ? "-" : "+"}
              </span>
            </button>
            {openQuestion === index && (
              <p
                className="p-4 subhead text-justify"
                dangerouslySetInnerHTML={{
                  __html: faq.description,
                }}
              ></p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
